import styled, { keyframes } from 'styled-components';
import { Box, Text } from '@usealloy/component-library';

const fadeInOut = keyframes`
  0%, 100% { opacity: 0.4; }
  50% { opacity: 1; }
`;

export const StyledAnimatedImage = styled.img`
  animation: ${fadeInOut} 4s ease-in-out infinite;
`;

export const StyledEmptyStateContainer = styled(Box)`
  height: 100%;
  padding-top: 60px;
  cursor: default;
`;

export const StyledDescriptionText = styled(Text)`
  color: var(--cl-text-secondary);
  max-width: 380px;
  text-align: center;
`;
